import { render, staticRenderFns } from "./StudyResultStudentSelect.vue?vue&type=template&id=af565684&lang=pug"
import script from "./StudyResultStudentSelect.vue?vue&type=script&lang=ts"
export * from "./StudyResultStudentSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports